import React, { Component } from "react";
import "./Table.css";
// import Checkbox from "@mui/material/Checkbox";

import TableRow from "./TableRow/TableRow";

class Table extends Component {
  render() {
    let { head, data, skipFirstColumn = false } = this.props;
    return (
      <div>
        <table>
          <thead>
            <tr>
              {/* <th>
                <Checkbox
                  checked={false}
                  value="checkedA"
                  inputProps={{
                    "aria-label": "primary checkbox"
                  }}
                />
              </th> */}
              {head.map((index, item) => (
                <th key={item}>{index}</th>
              ))}
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {data.map((item, index) => (
              <TableRow
                key={index}
                item={item}
                click={this.props.click}
                delete={this.props.delete}
                icon={this.props.icon}
                skipFirstColumn={skipFirstColumn}
              />
            ))}
          </tbody>
        </table>
      </div>
    );
  }
}

export default Table;
